export default "__VITE_ASSET__CImQIITW__"